import customAxios from "./axiosConfig";

const TaxRateService = {
  list: function (params) {
    var api_url = window.Urls["taxrate-list"]();
    return customAxios.get(api_url,  { params: params });
  },
};

export default TaxRateService;